<template>
  <div style="margin: 10px 0; min-height: 121px;">
    <!-- Tournament Name -->
    <div
      v-show="tournament"
      class="title is-3"
      style="color: green; margin-bottom: 5px;"
    >
      {{ tournament.name }}
      <span v-if="tournament.recurrence && tournament.recurrence.repeat">
        {{
          tournament.startTime
            | asDayjsFormat(
              `DD/MM/YYYY${
                tournament.recurrence.repeat.basis === "minute" ? " HH:mm" : ""
              }`
            )
        }}
      </span>
    </div>

    <!-- Round text -->
    <span v-show="tournamentGame.roundNumber" class="tag is-success is-large">
      Round {{ tournamentGame.roundNumber }}
    </span>
    <span v-show="tournamentGame.board" class="tag is-info is-large">
      Board {{ tournamentGame.board }}
    </span>

    <!-- Round Start Time -->
    <div v-show="tournamentGame.roundNumber" class="subtitle is-3">
      <span class="subtitle is-5">
        {{
          tournamentGame.roundStartTime || tournamentGame.startTime | asDateTime
        }}
      </span>
      <span class="subtitle is-5" v-show="roundHasEnded">
        (ended)
      </span>
    </div>

    <!-- Show after match -->
    <h3
      v-if="isMyGame && roundHasEnded && hasNextRound"
      class="title has-text-danger my-3"
    >
      Please go back to the Tournament Lobby before the next round begins
    </h3>
  </div>
</template>

<script>
import { firestore } from "@/services/firebase";
import { TournamentsAPI } from "@/services/api";
import { mapGetters } from "vuex";

export default {
  name: "TournamentGame",

  props: ["tournamentId", "matchId", "match"],

  data() {
    return {
      tournamentGame: {},
      tournament: {},
    };
  },

  computed: {
    ...mapGetters(["getUserId", "getPlayer"]),

    tournamentRef() {
      if (!isNaN(this.tournamentId)) return null;
      return firestore.collection("tournaments").doc(this.tournamentId);
    },

    playerColor() {
      if (!this.tournamentGame) return null;
      if (!this.getPlayer || !this.getPlayer.username) return null;
      if (this.tournamentGame.whiteUsername === this.getPlayer.username) {
        return "white";
      }
      if (this.tournamentGame.blackUsername === this.getPlayer.username) {
        return "black";
      }
      return null;
    },

    matchResult() {
      if (!this.match || !this.match.result) return null;
      return this.match.result;
    },

    isMyGame() {
      return (
        this.getPlayer &&
        (this.getPlayer.username === this.tournamentGame.whiteUsername ||
          this.getPlayer.username === this.tournamentGame.blackUsername)
      );
    },

    roundHasEnded() {
      if (!this.tournament || !this.tournamentGame) return null;
      return this.tournament.currentRound > this.tournamentGame.roundNumber;
    },

    hasNextRound() {
      if (!this.tournament || !this.tournamentGame) return null;
      return (
        this.tournamentGame.roundNumber < this.tournament.totalRounds &&
        this.tournament.currentRound < this.tournament.totalRounds
      );
    },
  },

  watch: {
    tournamentId: {
      immediate: true,
      handler(tournamentId) {
        if (!tournamentId) return;
        this.getTournament(this.tournamentId);
      },
    },

    matchId: {
      immediate: true,
      handler(matchId) {
        if (!this.tournamentId) return;
        if (!matchId) return;
        this.getTournamentGame(this.tournamentId, this.match_id).then(
          this.startTimer
        );
      },
    },
  },

  methods: {
    async getTournamentGame() {
      if (isNaN(this.tournamentId)) {
        if (this.tournamentGame.id) return;
        this.tournamentRef
          .collection("games")
          .where("matchGUID", "==", this.matchId)
          .limit(1)
          .get()
          .then((snapshot) => {
            if (!snapshot || !snapshot.docs || !snapshot.docs[0]) {
              console.log("no such game in tournament", this.tournamentId);
              return;
            }
            const document = snapshot.docs[0];
            this.$bind(
              "tournamentGame",
              this.tournamentRef.collection("games").doc(document.id)
            );
          });
        return;
      }

      await TournamentsAPI.getTournamentGame(
        this.tournamentId,
        this.matchId
      ).then((data) => {
        if (data) {
          this.tournamentGame = data;
        }
      });
    },

    async getTournament() {
      if (isNaN(this.tournamentId)) {
        this.$bind("tournament", this.tournamentRef);
        return;
      }

      await TournamentsAPI.getTournament(this.tournamentId, false).then(
        (data) => {
          if (data) {
            this.tournament = data;
          }
        }
      );
    },
  },
};
</script>

<style scoped></style>
